// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__3_PQ8","card":"Cards_card__hD4XU","email":"Cards_email__1Ltsm"};